import { render, staticRenderFns } from "./ActiveLT.vue?vue&type=template&id=484e66c8"
import script from "./ActiveLT.vue?vue&type=script&lang=js"
export * from "./ActiveLT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports